import GVIntelligenceChat from "@/components/crm/GVIntelligenceChat";

export default function IntelligencePage() {
  return <GVIntelligenceChat />;
}
